/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable import/no-named-as-default */
import React from "react";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  Image,
  TouchableWithoutFeedback,
} from "react-native";
import dayjs from "dayjs";

import t from "@constants/localization";
import colors from "@constants/color";
import CallIcon from "@assets/svg/newCall";
import Cash from "@assets/svg/RRD/Cash";
import Button from "@components/RRD/Button";
import Text from "@components/CustomText";

import PaymentMode from "./PaymentMode";
import ItemCard from "./Itemcard";

function PickupCard({
  item,
  openMaps,
  onPressCall,
  onPickupCardPress,
  onButtonPress,
}) {
  const PATH = "screens/MyTask";
  const formatDate = (date) => {
    return dayjs(date).format("dddd, DD MMMM YYYY, h:mmA");
  };
  return (
    <View style={styles.listView}>
      <View style={styles.cardHeaderContainer}>
        <View style={styles.view1}>
          <View style={styles.nameContainer}>
            <Text variant="body_text_2" style={styles.name}>
              {item?.user_name}
            </Text>
            <Text variant="caption_2" style={styles.distance}>
              {item?.distance}
            </Text>
          </View>
          <TouchableOpacity onPress={() => onPressCall(item)}>
            <CallIcon strokeColor="#2195F2" width={17} height={17} />
          </TouchableOpacity>
        </View>
        <TouchableOpacity onPress={() => openMaps(item?.cx_lat, item?.cx_lng)}>
          <Text variant="body_text_3" style={styles.address}>
            {item?.address}
          </Text>
        </TouchableOpacity>
      </View>
      <View>
        {Math.abs(item?.pay_by_cx) > 0 && (
          <View>
            <View style={styles.dashedLine} />
            <View style={styles.amountOverviewContainer}>
              <Cash pay={Math.sign(item?.pay_by_cx) === 1} />
              <Text
                variant="body_text_1"
                style={{ paddingHorizontal: 8, lineHeight: 26 }}
              >
                {t(
                  `${PATH}/${
                    Math.sign(item?.pay_by_cx) === 1 ? "pay_by_cx" : "pay_cx"
                  }`,
                )}
                <Text variant="body_text_2">{Math.abs(item?.pay_by_cx)}</Text>
              </Text>
            </View>
          </View>
        )}
        <View style={styles.horizontalSeparator} />
        {item?.pickups?.map((data, idx, arr) => (
          <TouchableWithoutFeedback
            key={`${data.count}-${data.amount}`}
            onPress={() => onPickupCardPress(data, item)}
          >
            <View
              style={{
                backgroundColor:
                  arr.length > 1
                    ? idx % 2 === 0
                      ? "default"
                      : "#F5F5F5"
                    : "default",
              }}
            >
              <View style={styles.cardMiddleContainer}>
                <View style={styles.view2}>
                  <View>
                    <Text variant="body_text_3" style={styles.text2}>
                      {t(`${PATH}/pickups/count`)}
                    </Text>
                    <Text variant="body_text_3" style={styles.text3}>
                      {data?.count}
                    </Text>
                  </View>
                  <View style={styles.separator} />
                  <View style={styles.cardItemSection}>
                    <View>
                      <Text variant="body_text_3" style={styles.text2}>
                        {t(`${PATH}/pickups/amount`)}
                      </Text>
                      <Text variant="body_text_3" style={styles.text3}>
                        {t(`${PATH}/rs`)}
                        {data?.amount}
                      </Text>
                    </View>
                    <PaymentMode
                      payment_tag={data?.payment_tag}
                      payment_mode={data?.payment_mode}
                    />
                  </View>
                </View>
              </View>
              {data?.return_req_items?.map(ItemCard)}
              <View style={styles.bottomButtonContainer}>
                {data?.status === "PENDING_PICKUP_FROM_CX" ? (
                  <View
                    style={[
                      styles.buttonContainer,
                      {
                        width: "50%",
                        alignSelf: "flex-end",
                      },
                    ]}
                  >
                    <Button
                      title={t(`${PATH}/markPickup`)}
                      btnColor={colors.plain_red}
                      onPress={() => {
                        onButtonPress("CONFIRM_PICKUP", data, item);
                      }}
                    />
                  </View>
                ) : (
                  <View style={styles.unmarkContainer}>
                    <Image
                      style={styles.tickContainer}
                      source={{
                        uri: "https://public-cdn.citymall.live/cm-admin-storage-public/cl_app_icon%2F1668094182235-pickup.png",
                      }}
                    />
                    <View style={{ flex: 1 }}>
                      <View style={styles.unmarkTextContainer}>
                        <Text
                          newfont
                          variant="body_text_2"
                          style={{ color: colors.plain_red }}
                        >
                          {t(`${PATH}/pickedUp`)}
                        </Text>
                        {data?.can_unmark_pickup ? (
                          <TouchableOpacity
                            onPress={() => {
                              onButtonPress("RESET_PICKUP", data, item);
                            }}
                          >
                            <Text variant="caption_1" style={styles.unmarkBtn}>
                              {t(`${PATH}/unmark`)}
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                      </View>
                      <Text
                        newfont
                        variant="caption_2"
                        style={styles.unmarkDate}
                      >
                        {formatDate(data?.picked_from_cx_at)}
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            </View>
          </TouchableWithoutFeedback>
        ))}
      </View>
    </View>
  );
}

export default PickupCard;

const styles = StyleSheet.create({
  bottomButtonContainer: {
    marginVertical: 16,
    paddingHorizontal: 16,
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  listView: {
    backgroundColor: colors.white,
    borderRadius: 10,
    elevation: 2,
    overflow: "hidden",
    marginHorizontal: 16,
    marginVertical: 8,
  },
  view1: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  view2: {
    flexDirection: "row",
    alignItems: "center",
  },
  text2: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  text3: {
    fontFamily: "NotoSansDevanagari-Bold",
  },
  name: {
    paddingHorizontal: 2,
  },
  address: {
    color: "#4274EA",
    textDecorationLine: "underline",
  },
  separator: {
    backgroundColor: colors.lighterBlack,
    height: 24,
    width: 1,
    marginLeft: 12,
    marginRight: 24,
  },
  horizontalSeparator: {
    backgroundColor: colors.lighterBlack,
    height: 1,
    width: "100%",
    // marginBottom: 16,
    alignSelf: "center",
  },
  cardItemSection: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  cardHeaderContainer: { padding: 16 },
  dashedLine: {
    flex: 1,
    opacity: 0.7,
    height: 1,
    borderWidth: 0.5,
    borderColor: colors.extraLightBlack,
    borderStyle: "dashed",
    borderRadius: 1,
  },
  nameContainer: { flexDirection: "row", alignItems: "center" },
  distance: {
    color: colors.mediumBlacklightBlack,
    marginLeft: 2,
    fontWeight: "500",
  },
  amountOverviewContainer: {
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 16,
  },

  cardMiddleContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    marginTop: 16,
    marginBottom: 8,
  },
  unmarkContainer: { width: "100%", flexDirection: "row" },
  unmarkTextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  unmarkBtn: {
    textDecorationLine: "underline",
    color: colors.mediumBlacklightBlack,
  },
  unmarkDate: { color: colors.mediumBlacklightBlack },
  tickContainer: {
    height: 20,
    width: 20,
    marginRight: 8,
  },
});
